module.exports = "/Public/build/c12d6eed43d097f0d3e3e2e630bd5a98.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/feature-article-logo.svg
// module id = 268
// module chunks = 0